module.exports = __webpack_public_path__ + "static/media/banner-mobile-amazon-5-percent@3x.0d82509b.png";